import { getImage } from 'gatsby-plugin-image';
import { PLATFORMS, PLATFORM_BG_COLOR_MAP } from '../../constants';

const DEFAULT_LINK_ORDER = 100;

export const formatIncrementedValue = (value, increment = 0) => {
  if (!value) return { before: value, number: null, after: null };

  const match = value.match(/\{\s*(?<number>\d+)\s*\}/);

  if (match) {
    const number = Number(match.groups?.number);
    if (Number.isNaN(number) === false) {
      return {
        before: value.substring(0, match.index),
        number: Math.max(number + increment, 0),
        after: value.substring(match.index + match[0].length),
      };
    }
  }

  return { before: value, number: null, after: null };
};

export const formatLinksV2 = (pageContext, increment = 0) => {
  const links = [];

  for (const platform of PLATFORMS) {
    if (Boolean(pageContext.data[platform]) === false) continue;

    const platformOrderRaw =
      platform === 'Onlyfans'
        ? 0
        : pageContext.data[`${platform}_Order`] ?? DEFAULT_LINK_ORDER;

    const platformOrder = Number(platformOrderRaw);

    links.push({
      platform: platform,
      link: pageContext.data[platform],
      platformTitle: formatIncrementedValue(
        pageContext.data[`${platform}PlatformTitle`] || '',
        increment
      ),
      order: platformOrder,
    });
  }

  for (const custom of pageContext.customLinks.edges) {
    const link = custom.node.data;

    if (!link['Custom_Link_Icon'] || !link['Custom_Link_Icon'].localFiles)
      continue;

    const linkOrderRaw = link.Order ?? DEFAULT_LINK_ORDER;
    const linkOrder = Number(linkOrderRaw);

    links.push({
      platform: null,
      icon: getImage(
        link['Custom_Link_Icon']?.localFiles?.[0]?.childImageSharp
      ),
      link: link['Custom_Link_URL'],
      platformTitle: formatIncrementedValue(
        link['Custom_Link_Text'] || '',
        increment
      ),
      order: linkOrder,
    });
  }

  const sortedLinks = links.sort((a, b) => a.order - b.order);
  return sortedLinks;
};

export const formatLinks = (pageContext, increment = 0) => {
  const links = [];
  const photosArray = pageContext.data.Photo_Gallery?.localFiles.map(
    (photo) => photo.childImageSharp
  );

  for (const platform of PLATFORMS) {
    if (Boolean(pageContext.data[platform]) === false) continue;

    const randomPhoto =
      photosArray[Math.floor(Math.random() * photosArray.length)];

    const platformTitle = formatIncrementedValue(
      pageContext.data[`${platform}PlatformTitle`] || '',
      increment
    );

    const platformBackground =
      getImage(
        pageContext.data[`${platform}PlatformBackground`]?.localFiles?.[0]
          ?.childImageSharp
      ) || randomPhoto;

    const platformOrderRaw =
      platform === 'Onlyfans'
        ? 0
        : pageContext.data[`${platform}_Order`] ?? DEFAULT_LINK_ORDER;

    const platformOrder = Number(platformOrderRaw);

    links.push({
      platform: platform,
      link: pageContext.data[platform],
      platformTitle: platformTitle,
      backgroundColor: PLATFORM_BG_COLOR_MAP[platform],
      backgroundImage: platformBackground,
      order: platformOrder,
    });
  }

  for (const custom of pageContext.customLinks.edges) {
    const link = custom.node.data;

    if (!link['Custom_Link_Icon'] || !link['Custom_Link_Icon'].localFiles)
      continue;

    const randomPhoto =
      photosArray[Math.floor(Math.random() * photosArray.length)];

    const linkOrderRaw = link.Order ?? DEFAULT_LINK_ORDER;
    const linkOrder = Number(linkOrderRaw);

    links.push({
      platform: null,
      icon: getImage(link['Custom_Link_Icon'].localFiles[0].childImageSharp),
      link: link['Custom_Link_URL'],
      platformTitle: formatIncrementedValue(
        link['Custom_Link_Text'] || '',
        increment
      ),
      backgroundColor: '#fff',
      backgroundImage: randomPhoto,
      order: linkOrder,
    });
  }

  const sortedLinks = links.sort((a, b) => a.order - b.order);
  return sortedLinks;
};
